module.exports = __webpack_public_path__ + "fonts/Inter-500-latin-ext37.fad2a54.woff2";